<template>
    <div class="corporateCultureBox">
        <aboutBannerVue tabIndex="6"></aboutBannerVue>
        <div :class="isMobile?'mobileShow':'socialBox'">
            <p class="font20 fontw">知识成果</p>
            <div class="clearfix mt42">
                <img :class="isMobile?'knowImg':'fl knowImg1'" src="@/assets/aboutUs/social/tu1.png" alt="">
                <div :class="isMobile?'knowCont':'fr knowCont1'">从实践中来，到实践中去。瑞和安惠总结从业二十余年的项目管理精华与实践经验，投入各专业领域精英数十人，经过五年的梳理与提炼，出版发行了“工程咨询理论与实践研究系列丛书”，共计10本著作。</div>
            </div>
            <div class="clearfix">
                <div :class="isMobile?'knowCont':'fl knowCont2'">
                    <p>主编新型建筑方式与工程项目管理创新丛书《全过程工程咨询管理》与《建筑企业项目化管理理论与实践》。</p>
                    <p>参编“全国二级造价工程师职业资格考试培训教材（河北版）”《建设工程计量与计价实务》（安装工程）教材。</p>
                    <p>“C市奥体中心，投资管控为核心的全过程工程咨询简析”“某商业广场项目全过程造价咨询实践”案例分别入选中价协 《全过程工程咨询典型案例—以投资控制为核心》2019和2020年版）。</p>
                </div>
                <img :class="isMobile?'knowImg':'fr knowImg2'" src="@/assets/aboutUs/social/tu2.png" alt="">
            </div>
            <div class="clearfix">
                <img :class="isMobile?'knowImg':'fl knowImg3'" src="@/assets/aboutUs/social/tu3.png" alt="">
                <div :class="isMobile?'knowCont':'fr knowCont3'">深耕技术创新，助力行业进步。瑞和安惠项目管理集团依托成熟的全过程工程咨询和BIM应用经验，依据现行国家标准，参与编制了多项国家及河北省工程建设标准。</div>
            </div>

        </div>
    </div>
</template>

<script>
import aboutBannerVue from '@/components/aboutBanner'
	export default {
		name:'CorporateCulture',
        components:{aboutBannerVue},
        data() {
            return {
            }
        },
        mounted(){
        },
        methods:{
        }
	}
</script>
<style scoped>
    .socialBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 42px;
        padding-bottom: 42px;
    }
    .tabT{
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .active{
        padding: 10px 15px;
        color: #fff;
        background-color: #247CD6;
        border-radius: 5px;
        border: none;
        margin-right: 16px;
        cursor: pointer;
        margin-top: 15px;
    }
    .moren{
        padding: 10px 15px;
        color: #333;
        background-color: #F4F4F4;
        border-radius: 5px;
        border: none;
        margin-right: 16px;
        cursor: pointer;
        margin-top: 15px;
    }
    .tabT .moren:hover{
        color: #247CD6;   
    }
    .socialShow{
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-top: 28px;
    }
    .socialList{
        width: 388px;
        margin-right: 18px;
        margin-bottom: 32px;
        text-align: center;
        cursor: pointer;
    }
    .socialList img{
        width: 388px;
        height:240px;
        margin-bottom: 20px;
    }
    .socialList:nth-child(3n){
        margin-right: 0;
    }
    .socialList:hover p{
        color: #247CD6;
    }
    .socialLists {
        width: 49%;
        margin-right: 2%;
        text-align: center;
        margin-bottom: 20px;
    }
    .socialLists:nth-child(2n){
        margin-right: 0;
    }
    .socialLists img{
        width: 100%;
        height: 120px;
        margin-bottom: 10px;
    }
    .knowImg{
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }
    .knowCont{
        width: 100%;
        margin-top: 20px;
        text-indent: 2em;
        line-height: 36px;
    }
    .knowImg1{
        width: 221px;
        height: 240px;
    }
    .knowCont1{
        width: 929px;
        margin-top: 80px;
        text-indent: 2em;
        line-height: 36px;
    }
    .knowImg2{
        width: 362px;
        height: 266px;
        margin-top: -20px;
    }
    .knowCont2{
        width: 836px;
        margin-top: 52px;
        text-indent: 2em;
        line-height: 36px;
    }
    .knowImg3{
        width: 765px;
        height: 254px;
    }
    .knowCont3{
        width: 416px;
        text-indent: 2em;
        line-height: 36px;
        margin-top: 80px;
    }
    .moreBtn div{
        color: #157FCC;
        width: 121px;
        height: 43px;
        line-height: 43px;
        text-align: center;
        border: 1px solid #247CD6;
        border-radius: 3px;
        cursor: pointer;
        font-size: 14px;
    }
    .mobileShow{
        padding-bottom: 30px;
    }
</style>